// extracted by mini-css-extract-plugin
export default {"loader-box":"Loader_loader-box__cLMPb","loader-background":"Loader_loader-background__02PzR","app-loader":"Loader_app-loader__Bf2Fx"};